const channelMismatchMessage = (rowChannel, currentChannel) => `This step's saved template is set to ${rowChannel}, but the step's current activity is ` +
    `${currentChannel}. Change the activity back, or delete this template from ops tooling ` +
    "before authoring a new one — creating a second template for this step isn't possible.";
/**
 * One authoritative resolution attempt for `target`. `isCurrent` is checked
 * after every await — a caller whose target has since changed can make it
 * return false, which drops the result on the floor. That's what makes a
 * late response from a superseded target structurally unable to land: there
 * is no flag or timestamp to compare, the caller that started this call is
 * simply no longer the one deciding whether its result counts.
 *
 * Deliberately does not read any cached "success" state — fetchList/
 * fetchDetail either resolve with a result this call fetched itself, or
 * reject. A stale cache entry can never look like resolution here.
 */
export async function resolveDripTemplateSession(deps, target, isCurrent, onState) {
    onState({ status: 'loading' });
    let rows;
    try {
        rows = await deps.fetchList(target.drip_id, target.version_number);
    }
    catch (err) {
        if (isCurrent()) {
            onState({ status: 'error', message: extractMessage(err) });
        }
        return;
    }
    if (!isCurrent())
        return;
    const row = rows.find((r) => r.step_id === target.step_id);
    if (row == null) {
        onState({ status: 'ready', templateId: null, initialTemplate: null });
        return;
    }
    if (row.channel !== target.channel) {
        onState({ status: 'blocked', reason: channelMismatchMessage(row.channel, target.channel) });
        return;
    }
    let detail;
    try {
        detail = await deps.fetchDetail(row.id);
    }
    catch (err) {
        if (isCurrent()) {
            onState({ status: 'error', message: extractMessage(err) });
        }
        return;
    }
    if (!isCurrent())
        return;
    onState({ status: 'ready', templateId: row.id, initialTemplate: detail });
}
const extractMessage = (err) => err instanceof Error ? err.message : 'Failed to load template data.';
